"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildIframeCoreQueryParams = void 0;
var buildIframeCoreQueryParams = function (props) {
    var country = props.country, currency = props.currency, locale = props.locale, step = props.step, siteType = props.siteType;
    var queryParams = new URLSearchParams({
        country: country,
        currency: currency,
        lang: locale,
        step: step,
        siteType: siteType,
    });
    return queryParams;
};
exports.buildIframeCoreQueryParams = buildIframeCoreQueryParams;
